import { render, staticRenderFns } from "./AddQuickMenu.vue?vue&type=template&id=348a9a7d&scoped=true"
import script from "./AddQuickMenu.vue?vue&type=script&lang=js"
export * from "./AddQuickMenu.vue?vue&type=script&lang=js"
import style0 from "./AddQuickMenu.vue?vue&type=style&index=0&id=348a9a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a9a7d",
  null
  
)

export default component.exports